var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 48,
    viewBox: "0 0 111 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 48V31.6788C0 30.9672 0.177913 30.3211 0.53374 29.7405C0.889567 29.1412 1.35776 28.6637 1.93832 28.3078C2.53761 27.952 3.19308 27.7741 3.90473 27.7741H16.2931C17.0048 27.7741 17.6602 27.952 18.2595 28.3078C18.8588 28.6637 19.3364 29.1412 19.6922 29.7405C20.048 30.3211 20.2259 30.9672 20.2259 31.6788V48H16.4898V41.2019H3.70809V48H0ZM3.70809 37.4938H16.4898V31.8474C16.4898 31.7537 16.4523 31.6788 16.3774 31.6226C16.3025 31.5477 16.2182 31.5103 16.1246 31.5103H4.04519C3.95155 31.5103 3.86728 31.5477 3.79237 31.6226C3.73618 31.6788 3.70809 31.7537 3.70809 31.8474V37.4938Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.771 48V40.4153L21.4446 27.7741H25.8269L32.6532 36.342L39.3952 27.7741H43.8617L34.5072 40.4434V48H30.771Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.594 48V27.7741H61.8871C62.5987 27.7741 63.2542 27.952 63.8535 28.3078C64.4528 28.6637 64.9303 29.1412 65.2862 29.7405C65.642 30.3211 65.8199 30.9672 65.8199 31.6788V44.0953C65.8199 44.807 65.642 45.4624 65.2862 46.0617C64.9303 46.6423 64.4528 47.1105 63.8535 47.4663C63.2542 47.8221 62.5987 48 61.8871 48H45.594ZM49.6111 44.2639H61.7185C61.8122 44.2639 61.8965 44.2358 61.9714 44.1796C62.0463 44.1047 62.0837 44.0204 62.0837 43.9268V31.8474C62.0837 31.7537 62.0463 31.6788 61.9714 31.6226C61.8965 31.5477 61.8122 31.5103 61.7185 31.5103H49.6111C49.5174 31.5103 49.4332 31.5477 49.3582 31.6226C49.3021 31.6788 49.274 31.7537 49.274 31.8474V43.9268C49.274 44.0204 49.3021 44.1047 49.3582 44.1796C49.4332 44.2358 49.5174 44.2639 49.6111 44.2639Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0219 48V27.7741H87.6466V31.5103H72.7581V36.0049H84.7251V39.7692H72.7581V44.2639H87.6466V48H69.0219Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4734 48V27.7741H94.5466L106.963 42.5503V27.7741H110.699V48H106.626L94.1814 33.1958V48H90.4734Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 20.2259V0H15.5066C16.2182 0 16.8643 0.177913 17.4449 0.53374C18.0442 0.889567 18.5217 1.36712 18.8775 1.96641C19.2334 2.54697 19.4113 3.19308 19.4113 3.90473V7.86565C19.4113 8.10911 19.3926 8.3432 19.3551 8.56794C19.3177 8.79267 19.2521 9.00804 19.1585 9.21404C19.4768 9.64478 19.7297 10.0942 19.9169 10.5624C20.1229 11.0306 20.2259 11.4988 20.2259 11.967V16.3212C20.2259 17.0329 20.048 17.6883 19.6922 18.2876C19.3364 18.8682 18.8588 19.3364 18.2595 19.6922C17.6602 20.048 17.0048 20.2259 16.2931 20.2259H0ZM4.04519 16.4898H16.1246C16.2182 16.4898 16.3025 16.4617 16.3774 16.4055C16.4523 16.3306 16.4898 16.2463 16.4898 16.1527V12.1356C16.4898 12.0419 16.4523 11.967 16.3774 11.9108C16.3025 11.8359 16.2182 11.7985 16.1246 11.7985H4.04519C3.95155 11.7985 3.86728 11.8359 3.79236 11.9108C3.73618 11.967 3.70809 12.0419 3.70809 12.1356V16.1527C3.70809 16.2463 3.73618 16.3306 3.79236 16.4055C3.86728 16.4617 3.95155 16.4898 4.04519 16.4898ZM4.04519 8.06229H15.338C15.4316 8.06229 15.5066 8.0342 15.5627 7.97801C15.6189 7.9031 15.647 7.81883 15.647 7.72519V4.07328C15.647 3.97964 15.6189 3.90473 15.5627 3.84855C15.5066 3.77364 15.4316 3.73618 15.338 3.73618H4.04519C3.95155 3.73618 3.86728 3.77364 3.79236 3.84855C3.73618 3.90473 3.70809 3.97964 3.70809 4.07328V7.72519C3.70809 7.81883 3.73618 7.9031 3.79236 7.97801C3.86728 8.0342 3.95155 8.06229 4.04519 8.06229Z",
    fill: "url(#paint0_linear_994_94)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.345 20.2259V0H41.9697V3.73618H27.0812V8.23084H39.0482V11.9951H27.0812V16.4898H41.9697V20.2259H23.345Z",
    fill: "url(#paint1_linear_994_94)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7964 20.2259V0H48.8697L61.2862 14.7762V0H65.0224V20.2259H60.9491L48.5045 5.42168V20.2259H44.7964Z",
    fill: "url(#paint2_linear_994_94)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_994_94",
    x1: 0,
    y1: 0,
    x2: 77.8461,
    y2: 9.73773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.183111,
    stopColor: "#FF56F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432593,
    stopColor: "#B936EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854443,
    stopColor: "#3BACE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#406AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_994_94",
    x1: 0,
    y1: 0,
    x2: 77.8461,
    y2: 9.73773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.183111,
    stopColor: "#FF56F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432593,
    stopColor: "#B936EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854443,
    stopColor: "#3BACE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#406AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_994_94",
    x1: 0,
    y1: 0,
    x2: 77.8461,
    y2: 9.73773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.183111,
    stopColor: "#FF56F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432593,
    stopColor: "#B936EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854443,
    stopColor: "#3BACE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#406AFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.db69ab3d72628dc90d79e6a2d59e174b.svg";
export { ForwardRef as ReactComponent };